export default __webpack_public_path__ + "static/media/photo--lg--98.928162d3.jpg";